import { Modal } from "antd";
import { useState, type FC } from "react";
import { TargetPicker } from "../../../components";
import type { DeploymentTarget, Project } from "../../../types";

interface SeoDeployModalProps {
  open: boolean;
  title: string;
  project: Project | null;
  targets?: DeploymentTarget[];
  deploying: boolean;
  onCancel: () => void;
  onConfirm: (environmentIds: string[]) => void;
}

// A SEO deploy is always a single item to a single project's own environments (see
// obsidian/Product/SEO Sync.md, "Portée de déploiement") — simpler than snippets' batch,
// cross-project-capable deploy modal, so this isn't a retyped copy of it, `TargetPicker` is the
// only piece actually shared.
export const SeoDeployModal: FC<SeoDeployModalProps> = ({ open, title, project, targets, deploying, onCancel, onConfirm }) => {
  const [selectedEnvironmentIds, setSelectedEnvironmentIds] = useState<string[]>([]);

  // Reset the selection whenever the modal (re)opens, adjusting state during render rather than
  // in an effect, same pattern as the snippets deploy modal.
  const [lastOpen, setLastOpen] = useState(open);
  if (open !== lastOpen) {
    setLastOpen(open);
    setSelectedEnvironmentIds([]);
  }

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={() => onConfirm(selectedEnvironmentIds)}
      confirmLoading={deploying}
      okButtonProps={{ disabled: selectedEnvironmentIds.length === 0 }}
    >
      <TargetPicker projects={project ? [project] : []} value={selectedEnvironmentIds} onChange={setSelectedEnvironmentIds} deployedTargets={targets} />
    </Modal>
  );
};
